// extracted by mini-css-extract-plugin
export var footer = "_of-5";
export var fulfillmentInput = "_of-0";
export var shipDateInput = "_of-1";
export var shipmentModal = "_of-2";
export var shipmentModalContent = "_of-3";
export var tableContainer = "_of-4";